// Created on 2023-08-03
// Created by Vitaut Tryputsin
//
// Copyright (c) 2023 OPEN CASCADE SAS
//
// This file is part of commercial software by OPEN CASCADE SAS,
// furnished in accordance with the terms and conditions of the contract
// and with the inclusion of this copyright notice.
// This file or any part thereof may not be provided or otherwise
// made available to any third party.
//
// No ownership title to the software is transferred hereby.
//
// OPEN CASCADE SAS makes no representation or warranties with respect to the
// performance of this software, and specifically disclaims any responsibility
// for any damages, special or consequential, connected with its use.
import { OccViewer } from "../viewer/viewer.js";
let aViewer = null;
/**
 * Wrap IPromise to Promise to do async c++ calls.
 * Don't forget to call promise resolve/reject functions in c++ to avoid memory leaks.
 * @param {function} theCppCall
 * @returns {Promise<void>}
 * @internal
 */
export function wrapIPromise(theCppCall) {
    if (!aViewer) {
        throw new Error("Viewer is not initialized");
    }
    return new Promise((resolve, reject) => {
        const callable = {
            obj: undefined,
            resolve: function () {
                this.obj.delete();
                resolve();
            },
            reject: function (theErr) {
                this.obj.delete();
                if (reject) {
                    reject(theErr);
                }
            },
        };
        const callableObject = aViewer.IPromise.implement(callable);
        callable.obj = callableObject;
        theCppCall(callableObject);
    });
}
/**
 * Set the viewer.
 * @internal
 */
OccViewer.onInit((theModule) => {
    aViewer = theModule;
});
